import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Qualificacao } from "app/models/qualificacao";
import { QualificacaoCnuRequest } from "app/models/qualificacao-cnu-request";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class QualificacaoGuiaMedicoCnuService {
   private API_URL: string = environment.apiUrl;

   constructor(
      private http: Http,
   ) { }

   obterQualificacoes(): Observable<Qualificacao[]> {
      return this.http.get(this.API_URL + 'QualificacaoCnu')
         .map(
            response => response.json(),
            error => error.json()
         );
   }

   public salvar(data: QualificacaoCnuRequest) {
      let url = `${this.API_URL}QualificacaoCnu`;
      return this.http.post(url, data).map(
         res => res.json(),
         error => error.json()
      );
   }

}


// WEBPACK FOOTER //
// ./src/app/app-services/qualificacao.service.ts